import React, { useMemo, Fragment, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Loading from 'components/Loading'
import Divider from '../../../Divider'
import Text from '../../../Text'

import { parseAllergies } from '@enlyt/helpers/parse'
import _ from 'lodash'
import localization from './localization'
import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'
import NoData from '../../../MyHealthContentArea/NoDataAvailableBar'
import { sortAllergies } from '@web/helpers/sortBy'
import Button from 'components/LoadMoreButton'
import FhirEnhancedTypes from 'stores/FhirEnhanced/Actions'
import SthWentWrong from 'containers/MyHealth/components/MyHealthContentArea/SthWentWrong'
import withLocalization from '@web/helpers/localizationUtils'
import LearnMoreButton from '@web/components/HealthLibraryLearnMore'
import {
  healthLibrary,
  healthLibraryLoading
} from '@web/stores/FhirEnhanced/Select'
import { useTranslation } from 'react-i18next'
import { parseHealthLibrary } from '@web/helpers/parseEnhanced'
import FhirEnhancedActions from '@web/stores/FhirEnhanced/Actions'
import { HEALTH_LIBRARY_MAPPING } from '@web/helpers/sources'

const Allergies = ({ name, loading, data, error, t }) => {
  const { theme } = useTheme()
  const styles = themeStyles(theme)
  const items = useMemo(() => parseAllergies(sortAllergies(data)), [data])
  const dispatch = useDispatch()
  const nextUrl = _.filter(data?.link, item => item.relation === 'next')[0]?.url

  const healthArticles = useSelector(healthLibrary)
  const [healthArticleData, setHealthArticleData] = useState([])
  const [currentArticleCode, setCurrentArticleCode] = useState('')
  const healthArticlesLoading = useSelector(healthLibraryLoading)
  const { i18n } = useTranslation()
  const language = i18n.language === 'es' ? 'es' : 'en'

  useEffect(
    () => {
      if (!healthArticlesLoading?.[currentArticleCode]) {
        const healthArticleData = _.get(
          healthArticles?.[language],
          currentArticleCode,
          []
        )
        const parsedData = parseHealthLibrary(healthArticleData)
        setHealthArticleData(parsedData)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [healthArticlesLoading?.[currentArticleCode]]
  )

  const openLearnMorePopup = ({ terms }) => {
    const key = terms
    const healthArticleData = _.get(healthArticles?.[language], key, [])
    setCurrentArticleCode(key)
    if (!_.isEmpty(healthArticleData)) {
      const parsedData = parseHealthLibrary(healthArticleData)
      setHealthArticleData(parsedData)
    } else if (!healthArticlesLoading?.[key]) {
      dispatch(
        FhirEnhancedActions.healthLibrarySearch(
          language,
          terms,
          undefined,
          HEALTH_LIBRARY_MAPPING.ALLERGIES
        )
      )
    }
  }
  const handleCloseLearnMorePopup = () => {
    setHealthArticleData([])
  }

  const loadMoreOnClick = () => {
    dispatch(FhirEnhancedTypes.allergyIntoleranceSearchLoadMore(nextUrl))
  }

  return (
    <>
      <div style={styles.container}>
        {loading && _.isEmpty(items) && <Loading />}
        {!_.isEmpty(items) &&
          items.map((item, index) => (
            <Fragment key={index}>
              <div style={styles.testContainer}>
                <Text
                  style={styles.text}
                  bold
                  label={t('allergy')}
                  text={item.title}
                />
                <Text
                  style={styles.textDate}
                  label={t('dateIdentified')}
                  text={item.recorded}
                />
                <Text
                  style={styles.textRight}
                  label={t('reactions')}
                  text={item.reactions}
                />
              </div>
              <LearnMoreButton
                data={healthArticleData}
                onClick={() => openLearnMorePopup({ terms: item?.title })}
                onClose={handleCloseLearnMorePopup}
                shouldLoading={healthArticlesLoading?.[currentArticleCode]}
                mapKey={item.title}
                buttonStyle={styles.learnMoreButton}
                language={language}
              />
              {index !== items.length - 1 && <Divider />}
            </Fragment>
          ))}
        {!loading &&
          _.isEmpty(items) &&
          (error ? <SthWentWrong /> : <NoData name={name} />)}
      </div>
      {!_.isEmpty(items) && nextUrl && (
        <Button onClick={loadMoreOnClick} loading={loading} />
      )}
    </>
  )
}

export default withLocalization(Allergies, localization)
